import { render, staticRenderFns } from "./UseOfFunds.vue?vue&type=template&id=42057392&scoped=true&"
import script from "./UseOfFunds.vue?vue&type=script&lang=js&"
export * from "./UseOfFunds.vue?vue&type=script&lang=js&"
import style0 from "./UseOfFunds.vue?vue&type=style&index=0&id=42057392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42057392",
  null
  
)

export default component.exports